import post01 from './news-post1.json';
import post02 from './news-post2.json';
import post03 from './news-post3.json';
import post04 from './news-post4.json';
import post05 from './news-post5.json';
import post06 from './news-post6.json';
import post07 from './news-post7.json';

export const banner = {
  cover: 'https://img.alicdn.com/tfs/TB1ywawJXYqK1RjSZLeXXbXppXa-1920-627.png',
  mcover: 'https://gw.alicdn.com/tfs/TB1yDSbMZbpK1RjSZFyXXX_qFXa-750-320.png',
  title: '新闻动态',
};

export const news = [
  {
    pid: '1',
    title: '阿里健康、浙江扁鹊一行到访物产健康',
    cover: 'https://img.alicdn.com/tfs/TB1DeA7Cxv1gK0jSZFFXXb0sXXa-490-308.png',
    icon: 'https://gw.alicdn.com/tfs/TB1QHtENVYqK1RjSZLeXXbXppXa-74-74.png',
    class: 'icon-hospital',
    desc:
      '4月8日，阿里健康政府事务总监康伟锋、浙江扁鹊CEO袁孔虎等一行到访物产健康，集团办公室主任助理蔡舒陪同。物产健康党委书记、董事长洪卫良，董事、副总经理王罡…',
    time: '发布时间：2020-04-08',
    path: '/about?post=1',
  },
  {
    pid: '2',
    title: '现在凭“健康码”，也可以看病了！',
    cover: 'https://img.alicdn.com/tfs/TB1i6c4Crr1gK0jSZFDXXb9yVXa-490-308.png',
    icon: 'https://gw.alicdn.com/tfs/TB1gy8vN6DpK1RjSZFrXXa78VXa-76-58.png',
    class: 'icon-ecard',
    desc:
      '除了查看新冠肺炎的接触风险，现在“健康码”也可以看病啦！近日，由阿里健康下属浙江扁鹊公司建设和运营的“电子健康卡”在浙江省内率先与疫情防控健康码实现互联互通。',
    time: '发布时间：2020-2-27',
    path: '/about?post=2',
  },
  {
    pid: '3',
    title: '浙江牵手湖北 互联网医院援鄂义诊通道今日上线',
    cover: 'https://img.alicdn.com/tfs/TB15V75CCf2gK0jSZFPXXXsopXa-490-308.png',
    icon: 'https://gw.alicdn.com/tfs/TB1D0xFNVzqK1RjSZFoXXbfcXXa-66-66.png',
    class: 'icon-face',
    desc:
      '新蓝网-中国蓝新闻客户端2月27日讯（中国蓝融媒体中心 新蓝网记者 喻惠婷 通讯员 陈娜）在国家卫健委规划司统筹指导下，浙江省卫生健康委牵手阿里共同开发了互联网医…',
    time: '发布时间：2020-2-27',
    path: '/about?post=3',
  },
  {
    pid: '4',
    title: '国家卫健委发函推介浙江“阿里版”疫情防控系统',
    cover: 'https://img.alicdn.com/tfs/TB1iBg3CuT2gK0jSZFvXXXnFXXa-490-308.png',
    icon: 'https://gw.alicdn.com/tfs/TB1D0xFNVzqK1RjSZFoXXbfcXXa-66-66.png',
    class: 'icon-face',
    desc:
      'SEE = Seeking Experience & Engineering，由蚂蚁金服由蚂蚁金服集团每年举办 1-2 次，包括专业分由蚂蚁金服SEE = Seeking Experience & Engineering。',
    time: '发布时间：2020-2-14',
    path: '/about?post=4',
  },
  {
    pid: '5',
    title: '浙江省上线服务+监管一体化互联网医院平台',
    cover: 'https://img.alicdn.com/tfs/TB1xUPfykL0gK0jSZFtXXXQCXXa-960-572.png',
    icon: 'https://gw.alicdn.com/tfs/TB1QHtENVYqK1RjSZLeXXbXppXa-74-74.png',
    class: 'icon-hospital',
    desc:
      '浙江省卫生健康委与阿里健康、支付宝筹备了半年多时间，在浙江省上线了该互联网医院平台，首创了服务+监管为一体的模式。',
    time: '发布时间：2019-01-23',
    path: '/about?post=5',
  },
  {
    pid: '6',
    title: '浙江省居民电子健康卡——省中首发！',
    cover: 'https://gw.alicdn.com/tfs/TB12LfwPmzqK1RjSZPxXXc4tVXa-920-532.jpg',
    icon: 'https://gw.alicdn.com/tfs/TB1gy8vN6DpK1RjSZFrXXa78VXa-76-58.png',
    class: 'icon-ecard',
    desc:
      '浙江省居民电子健康卡是浙江省卫生健康委按照国家标准，为方便在我省医疗机构就诊的人民群众，实现跨机构和跨地域的线上线下一体化医疗健康服务而提供的电子卡。',
    time: '发布时间：2018-10-26',
    path: '/about?post=6',
  },
  {
    pid: '7',
    title: '阿里健康联合支付宝实现全流程刷脸就医',
    cover: 'https://gw.alicdn.com/tfs/TB1T1zAPb2pK1RjSZFsXXaNlXXa-920-532.jpg',
    icon: 'https://gw.alicdn.com/tfs/TB1D0xFNVzqK1RjSZFoXXbfcXXa-66-66.png',
    class: 'icon-face',
    desc:
      '接下来，阿里健康与支付宝将在杭州上线就诊助手、院内导航、在线问医生等就医服务。阿里健康、支付宝、余杭一院三方历时半年，经过系统开发和联合调试，正式在余杭一院接入并且跑通了医保诊间结算。在试运行的一个半月内，“刷脸就医”超过1000笔，200位病人通过刷脸在院内完成了建档。',
    time: '发布时间：2018-10-20',
    path: '/about?post=7',
  },
];

const postData = {
  post01,
  post02,
  post03,
  post04,
  post05,
  post06,
  post07,
};

export const newsData = {
  title: '新闻动态',
  subtitle: 'news information',
  extra: {
    title: '新闻列表',
    path: '/about',
  },
  path: '/about',
  news: news.map((item, idx) => {
    const postObj = postData[`post0${idx + 1}`];
    item.tags = postObj.tags;
    item.content = postObj.content;
    return item;
  }),
};
